import { render, staticRenderFns } from "./slid-dialog.vue?vue&type=template&id=36a26bb9&scoped=true&"
import script from "./slid-dialog.vue?vue&type=script&lang=js&"
export * from "./slid-dialog.vue?vue&type=script&lang=js&"
import style0 from "./slid-dialog.vue?vue&type=style&index=0&id=36a26bb9&lang=scss&scoped=true&"
import style1 from "./slid-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a26bb9",
  null
  
)

export default component.exports